module.exports = __webpack_public_path__ + "static/media/futuregrad_logotype_color.b56bf390.svg";